import React, { useState, useContext, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { FaSearch, FaTrash } from "react-icons/fa";
import Select from "react-select";
import { InfoContext } from "../providers/InfosContextProvider";
import { useNavigate } from "react-router-dom";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#a02020"
      : state.isFocused
        ? "#f0f0f0"
        : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#000000",
    "&:active": {
      backgroundColor: "#a02020",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000000",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const Search = () => {
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedBedrooms, setSelectedBedrooms] = useState(null);
  const [selectedBathrooms, setSelectedBathrooms] = useState(null);
  const [filteredCount, setFilteredCount] = useState(0);

  const { options, texts, language, houses } = useContext(InfoContext);
  const [filteredOptions, setFilteredOptions] = useState(options);

  const navigate = useNavigate();

  const clearAllSelections = () => {
    setSelectedTransaction(null);
    setSelectedType(null);
    setSelectedBedrooms(null);
    setSelectedBathrooms(null);
  };

  const handleSearch = () => {
    if (filteredCount === 0) return;
    const params = {};

    if (selectedTransaction && selectedTransaction.value) {
      params.transaction = selectedTransaction.value;
    }

    if (selectedType && selectedType.value) {
      params.type = selectedType.value;
    }

    if (selectedBedrooms && selectedBedrooms.value) {
      params.bedrooms = selectedBedrooms.value;
    }

    if (selectedBathrooms && selectedBathrooms.value) {
      params.bathrooms = selectedBathrooms.value;
    }

    const queryParams = new URLSearchParams(params).toString();

    navigate(`/results?${queryParams}`);
  };

  useEffect(() => {
    const filterHouses = () => {
      let filtered = houses;

      if (selectedTransaction) {
        filtered = filtered.filter(
          (casa) => casa.transaction === selectedTransaction.value,
        );
      }
      if (selectedType) {
        filtered = filtered.filter(
          (casa) => casa.typeProperty === selectedType.value,
        );
      }
      if (selectedBedrooms) {
        filtered = filtered.filter(
          (casa) => casa.bedrooms === Number(selectedBedrooms.value),
        );
      }
      if (selectedBathrooms) {
        filtered = filtered.filter(
          (casa) => casa.bathrooms === Number(selectedBathrooms.value),
        );
      }

      setFilteredCount(filtered.length);
    };

    filterHouses();
  }, [
    selectedTransaction,
    selectedType,
    selectedBedrooms,
    selectedBathrooms,
    houses,
  ]);

  useEffect(() => {
    const updateOptions = () => {
      setFilteredOptions({
        transaction: options.transaction || options.transaction,
        type: options.type || options.type,
        bedrooms: options.bedrooms || options.bedrooms,
        bathrooms: options.bathrooms || options.bathrooms,
      });
    };

    updateOptions();
  }, [language, options]);

  const getButtonText = () => {
    if (filteredCount === 0) return texts.search.semResultados;
    if (filteredCount === 1) return texts.search.verImovel;
    return texts.search.verImoveis.replace("{count}", filteredCount);
  };

  return (
    <div className="search-container">
      <div className="search-content">
        <Form>
          <Row className="align-items-end">
            <Col className="inputs" md={6} lg={3}>
              <Form.Group controlId="type-transaction">
                <Select
                  options={filteredOptions.transaction}
                  value={selectedTransaction}
                  onChange={setSelectedTransaction}
                  styles={customStyles}
                  placeholder={`${texts.search.transaction}`}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                />
              </Form.Group>
            </Col>

            <Col className="inputs" md={6} lg={3}>
              <Form.Group controlId="type-property">
                <Select
                  options={filteredOptions.type}
                  value={selectedType}
                  onChange={setSelectedType}
                  styles={customStyles}
                  placeholder={`${texts.search.type}`}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                />
              </Form.Group>
            </Col>

            <Col className="inputs" md={6} lg={3}>
              <Form.Group controlId="bedrooms">
                <Select
                  options={filteredOptions.bedrooms}
                  value={selectedBedrooms}
                  onChange={setSelectedBedrooms}
                  styles={customStyles}
                  placeholder={`${texts.search.bedrooms}`}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                />
              </Form.Group>
            </Col>

            <Col className="inputs" md={6} lg={3}>
              <Form.Group controlId="bathrooms">
                <Select
                  options={filteredOptions.bathrooms}
                  value={selectedBathrooms}
                  onChange={setSelectedBathrooms}
                  styles={customStyles}
                  placeholder={`${texts.search.bathrooms}`}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                />
              </Form.Group>
            </Col>
          </Row>

          <Col md={12} lg={12} className="text-right">
            <div className="icone-search">
              <Button
                onClick={handleSearch}
                disabled={filteredCount === 0}
                style={{ opacity: filteredCount === 0 ? 0.5 : 1 }}
              >
                <FaSearch /> {getButtonText()}
              </Button>

              <Button className="btn-limpar" onClick={clearAllSelections}>
                <FaTrash /> {`${texts.search.limpar}`}
              </Button>
            </div>
          </Col>
        </Form>
      </div>
    </div>
  );
};

export default Search;
